import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import MuiStepper, { StepperProps } from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepIcon-root.Mui-active': {
    color: theme.palette.grey[900],
  },
}));

type Props = {
  steps: Array<string>;
} & Pick<StepperProps, 'orientation' | 'activeStep' | 'className'>;

export const Stepper: React.FC<Props> = ({ steps, ...rest }) => {
  return (
    <MuiStepper orientation="horizontal" {...rest}>
      {steps.map((step) => (
        <Step key={step}>
          <StyledStepLabel>{step}</StyledStepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};

export default Stepper;
